export default {
  pageSizes: [5, 10],
};
